(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalSwitch', ['$timeout', RfGlobalSwitchFn]);

    /* bootstrap switch */
    function RfGlobalSwitchFn($timeout) {

        var directive = {
            link: link,
            restrict: 'A',
            require: '?ngModel'

        };
        return directive;

        function link(scope, element, attrs, ngModel) {
           
            element.on('switchChange.bootstrapSwitch', function (event, state) {
                if (ngModel) {
                    scope.$apply(function () {
                        ngModel.$setViewValue(state);
                    });
                }
            });

            var watchUnbinder = null;
            $timeout(function() { 
                 watchUnbinder = scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                    if (newValue) {
                        element.bootstrapSwitch('state', true, true);
                    } else {
                        element.bootstrapSwitch('state', false, true);
                    }
                });

                element.bootstrapSwitch();
            }); 

            // set switch disabled, when the disabled attr is changed with ng-disabled
            var disabledWatcher = attrs.$observe("disabled", function(disabled) {
                element.bootstrapSwitch('disabled', disabled);
            });

            scope.$on('$destroy', function () {
                if (watchUnbinder) {
                    watchUnbinder();
                    watchUnbinder = null;
                }

                if (disabledWatcher) {
                    disabledWatcher();
                }

                element.off('switchChange.bootstrapSwitch');
            });
        }
    }

})();